class EditMembers {
    constructor() {
        this.memberGroups = null;
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');

        this.editTeamMemberEvents();
        this.editTeamMemberInput();
    }
    editTeamMemberEvents(){
        const thisClass = this;
        /** When user click on edit button redraw modal form and get member values */
        $(document).on('click', '.edit-member', function(e) {
            let vpnUserID = $(this).parent()[0].id;
            thisClass.showEditTeamMemberModal(vpnUserID);
        });
        /** If url contains #edit-member - show member */
        if(window.location.href.includes('edit-member') && new URLSearchParams(window.location.search).get('vpnUserID')){
            thisClass.showEditTeamMemberModal(new URLSearchParams(window.location.search).get('vpnUserID'));
        }

        /** Open avatars modal */
        $(document).on('click', '#editTeamMemberAvatarBtn', function(e) {
            new bootstrap.Modal(document.getElementById('change_team_member_avatar_modal'), {}).show();
        });
        /** Open avatars modal */
        $(document).on('click', '#change_team_member_avatar_modal .symbol', function(e) {
            let img = $(this).find('img');
            let avatarSrc = (img[0].getAttribute('src')).replace(/ /g, "%20");
            $('#team-member-avatar').attr('src',avatarSrc);
            $('#frm-generalForms-editTeamMemberForm-editTeamMemberForm input[name="avatarID"]').val($(this).find('img')[0].getAttribute('data-value'));
            bootstrap.Modal.getInstance(document.getElementById('change_team_member_avatar_modal')).hide();
        });

        $(document).on('click', '.back-to-edit-member', function(e) {
            let modalID = $(this).closest('.modal.fade.show')[0].attributes.id.value;
            bootstrap.Modal.getInstance(document.getElementById(modalID)).hide();
            new bootstrap.Modal(document.getElementById('edit_team_member_modal'), {}).show();
        });
    }
    /** Redraw edit member form by vpnUserID */
    showEditTeamMemberModal(vpnUserID){
        new ModalLoading();
        naja.makeRequest('GET', '/team-members/?do=getTeamMemberInfo', {
            'vpnUserID': vpnUserID,
            'organizationID': this.organizationID
        }, {
            history: false // Prevent URL changes in browser history
        }).then((response) => {
            if(response){
                const editTeamMemberModal = document.getElementById('edit_team_member_modal');
                this.editTeamMemberSideBarActions(response.vpnUserInfo.uuid, response.vpnUserInfo.hideConfigFiles);
                this.initTagifyInEditMemberForm(response.vpnUserInfo.groupsArr);
                this.editMemberFormValidation(response.vpnUserInfo);
                this.initDeleteMember(editTeamMemberModal, response.vpnUserInfo);

                // Init advanced settings dropdown
                KTMenu.createInstances();

                // Init all popovers
                const popoverTriggerList = [].slice.call(document.querySelectorAll('#edit_team_member_modal [data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });

                this.hideGeneralModals(editTeamMemberModal);
                new ModalLoading(editTeamMemberModal);
            }
        }).catch(error => {
            new ModalLoading();
            toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
        });
    }
    initDeleteMember(editTeamMemberModal, vpnUserInfo){
        const thisClass = this;
        const deleteMemberButton = editTeamMemberModal.querySelector('.delete-member');
        if(deleteMemberButton){
            deleteMemberButton.addEventListener('click', function () {
                let html = `
                    <span class="text-center text-primary">Member `+(vpnUserInfo.name !== undefined && vpnUserInfo.name ? `<b>`+vpnUserInfo.name+`</b> ` : ``)+`is going to be completely deleted!</span>
                    <div class="text-center text-primary mt-5"><b>Please note:</b> Deleting this Member will also delete all records (logs) related to their activities.</div>
                    <div class="form-check mt-5">
                        <input class="form-check-input float-none corsor-pointer" name="agreeSwalCheckbox" type="checkbox" value="" id="agreeSwalCheckbox" />
                        <label class="form-check-label text-primary corsor-pointer" for="agreeSwalCheckbox">
                            I agree
                        </label>
                    </div>`;
                Swal.fire({
                    html: html,
                    icon: "warning",
                    iconColor: "#FF5206",
                    buttonsStyling: false,
                    reverseButtons: true,
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete!",
                    customClass: {
                        confirmButton: "btn btn-danger mt-0 cy-member-delete-confirm-btn",
                        cancelButton: 'btn btn-light-primary mt-0 cy-member-delete-cancel-btn',
                    },
                    showLoaderOnConfirm: true,
                    returnFocus: false,
                    preConfirm: () => {
                        let swalCheckbox = document.querySelector('input[name="agreeSwalCheckbox"]');
                        if(swalCheckbox && !swalCheckbox.checked){
                            Swal.showValidationMessage(`You need to agree`);
                            return;
                        }

                        return fetch('/team-members?do=removeTeamMember&organizationID='+thisClass.organizationID+'&vpnUserID='+vpnUserInfo.uuid)
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error(response.statusText)
                                }
                                return response.json();
                            }).catch(error => {
                                Swal.showValidationMessage(`Request failed: ${error}`)
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                    allowEscapeKey: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.isConfirmed) {
                        if(result.value === 'deleted') {
                            toastr.success('Member has been deleted.');
                            bootstrap.Modal.getOrCreateInstance(editTeamMemberModal).hide();
                            new PageDatatableReload();

                            let numberOfMembersElement = $(".number-of-members");
                            if(numberOfMembersElement){
                                numberOfMembersElement.text(numberOfMembersElement.text() - 1);
                                if(numberOfMembersElement.parent().hasClass('badge-light-danger')){
                                    numberOfMembersElement.parent().removeClass('badge-light-danger');
                                    numberOfMembersElement.parent().addClass('badge-light-primary');
                                }
                            }
                        } else {
                            thisClass.fireAdminBlockedSwal(result.value);
                        }
                    }
                });
            });
        }
    }
    fireAdminBlockedSwal(names) {
        Swal.fire({
            html: `<span class="text-center text-primary"><b>`+names+`</b> has been blocked due to violating Acceptable Usage Policy. For this reason, we have restricted actions associated with your Members. If you wish to continue, please contact our support team.</span>`,
            icon: "warning",
            iconColor: "#FF5206",
            buttonsStyling: false,
            reverseButtons: true,
            showCancelButton: true,
            confirmButtonText: '<a href="https://www.goodaccess.com/contact" target="_blank" class="text-white">\n' +
                '                  <i class="text-white fa-solid fa-arrow-up-right-from-square"></i> Contact us\n' +
                '               </a>',
            customClass: {
                confirmButton: "btn btn-danger mt-0",
                cancelButton: 'btn btn-light-primary mt-0',
            },
        });
    }
    hideGeneralModals(editTeamMemberModal){
        let editGroupModal = document.getElementById('edit_vpn_user_group_modal');
        if(editGroupModal && editGroupModal.classList.contains('show')){
            bootstrap.Modal.getInstance(editGroupModal).hide();
            new AddBackLinkToModal(editGroupModal, editTeamMemberModal);
        }
        let editDeviceModal = document.getElementById('edit_device_modal');
        if(editDeviceModal && editDeviceModal.classList.contains('show')){
            bootstrap.Modal.getInstance(editDeviceModal).hide();
            new AddBackLinkToModal(editDeviceModal, editTeamMemberModal);
        }
        let editAccessCardModal = document.getElementById('edit_access_card_modal');
        if(editAccessCardModal && editAccessCardModal.classList.contains('show')){
            bootstrap.Modal.getInstance(editAccessCardModal).hide();
            new AddBackLinkToModal(editAccessCardModal, editTeamMemberModal);
        }
        let createAccessCardModal = document.getElementById('create_access_card_modal');
        if(createAccessCardModal && createAccessCardModal.classList.contains('show')){
            bootstrap.Modal.getInstance(createAccessCardModal).hide();
            new AddBackLinkToModal(createAccessCardModal, editTeamMemberModal);
        }
        let editDevicePostureCheckModal = document.getElementById('edit_device_posture_check_modal');
        if(editDevicePostureCheckModal && editDevicePostureCheckModal.classList.contains('show')){
            bootstrap.Modal.getInstance(editDevicePostureCheckModal).hide();
            new AddBackLinkToModal(editDevicePostureCheckModal, editTeamMemberModal);
        }
        let createDevicePostureCheckModal = document.getElementById('create_device_posture_check_modal');
        if(createDevicePostureCheckModal && createDevicePostureCheckModal.classList.contains('show')){
            bootstrap.Modal.getInstance(createDevicePostureCheckModal).hide();
            new AddBackLinkToModal(createDevicePostureCheckModal, editTeamMemberModal);
        }
        let gatewayPortForwardModal = document.getElementById('gateway_port_forward_modal');
        if(gatewayPortForwardModal && gatewayPortForwardModal.classList.contains('show')){
            bootstrap.Modal.getInstance(gatewayPortForwardModal).hide();
            new AddBackLinkToModal(gatewayPortForwardModal, editTeamMemberModal);
        }
        let mostActiveUsersDatatable = document.getElementById('most_active_users_table');
        if(mostActiveUsersDatatable && mostActiveUsersDatatable.classList.contains('show')){
            bootstrap.Modal.getInstance(mostActiveUsersDatatable).hide();
            new AddBackLinkToModal(mostActiveUsersDatatable, editTeamMemberModal);
        }
    }
    /** If user click on pencil next to text, transform it into input */
    editTeamMemberInput(){
        $(document).on('click', '#frm-generalForms-editTeamMemberForm-editTeamMemberForm .editable-text .edit-section', function(e) {
            let mainDiv = $(this).parent().parent();
            let input = mainDiv.find('.not-edit');
            input.removeClass('not-edit d-none');
            mainDiv.find('.editable-text').remove();
            // Init password meter and set new validation
            if($(this).hasClass('change-password')){
                // Init advanced settings submenu and password meter
                KTPasswordMeter.createInstances();
            }
        });
    }
    /** Init input tagify for groups */
    async initTagifyInEditMemberForm(groupsArr) {
        const thisClass = this;
        const groupsInput = document.querySelector('#frm-generalForms-editTeamMemberForm-editTeamMemberForm input[name=groups]');
        let notice = $('#editMemberFormGroupNotice');
        if (groupsInput) {
            if (!thisClass.memberGroups) {
                thisClass.memberGroups = await fetch('/team-members/?do=getMemberGroups&organizationID=' + thisClass.organizationID)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(response.statusText)
                        }
                        return response.json();
                    });
            }
            let tagify = new GroupsTagify(groupsInput, thisClass.memberGroups);
            tagify.on('add', function (e) {
                if (e.detail.data.isInAccessCards && notice) {
                    notice.removeClass('d-none');
                }
            }).on('remove', function (e) {
                let values = e.detail.tagify.value;
                for (let i in values) {
                    if (values[i].isInAccessCards === true) {
                        break;
                    }
                }
                notice.addClass('d-none');
            });
            let names = [];
            for (let i = 0; i < groupsArr.length; i++) {
                names[i] = groupsArr[i]['name'];
            }
            tagify.addTags(names);
        }
    }
    editMemberFormValidation(vpnUserInfo){
        let form = document.getElementById('frm-generalForms-editTeamMemberForm-editTeamMemberForm');
        if(form){
            let submitButton = document.getElementById('edit_team_member_form_submit');
            let deleteButton = document.getElementById('edit_team_member_form_delete');
            let validatePassword = function() {
                const passwordMeter = KTPasswordMeter.getInstance(form.querySelector('[data-kt-password-meter="true"]'));
                return (passwordMeter.getScore() === 100);
            };
            let excludeName = function (){
                return (vpnUserInfo.avatarID && (vpnUserInfo.password || vpnUserInfo.isIdp)) && (vpnUserInfo.isIdp === 1 || vpnUserInfo.isOwner);
            }
            let excludePassword = function (){
                return form.querySelectorAll('.edit-section.change-password').length === 1;
            }

            /** validate form for team member */
            let validator = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'name': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required',
                                },
                                stringLength: {
                                    max: 45,
                                    message: 'Name cannot be over 45 characters',
                                },
                                regexp: {
                                    regexp: /^[ěščřžýáíéóúůďťňĎŇŤŠČŘŽÝÁÍÉÚŮa-zA-Z0-9' _.-]*$/,
                                    message: 'Only these special characters are allowed. (_.-)',
                                },
                            }
                        },
                        'password': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 45,
                                    message: 'Password has to be between 8 and 45 characters long',
                                },
                                regexp: {
                                    regexp: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~`!#@$%\^&*+=\-\[\]\\\';,\/{}|\\":<>\?()§_´¨.])[A-Za-z\d[~`!#@$%\^&*+=\-\[\]\\\';,\/{}|\\":<>\?()§_´¨.]{8,45}$/,
                                    message: 'You used a forbidden character',
                                },
                                callback: {
                                    message: 'Please enter valid password',
                                    callback: function() {
                                        return validatePassword();
                                    }
                                }
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                        icon: new FormValidation.plugins.Icon({
                            valid: 'fa fa-check',
                            invalid: 'fa fa-times',
                            validating: 'fa fa-refresh',
                        }),
                        excluded: new FormValidation.plugins.Excluded({
                            excluded: function(field, element, elements) {
                                if(field === 'name'){
                                    return excludeName();
                                } else if(field === 'password'){
                                    return excludePassword();
                                }
                                return false;
                            }
                        }),
                    }
                }
            ).on('core.element.validated', function(e) {
                if(e.element.attributes.name.value === 'password' || e.element.classList.contains('d-none')){
                    // Get the icon plugin instance
                    const iconPlugin = validator.getPlugin('icon');
                    const iconElement = iconPlugin && iconPlugin.icons.has(e.element) ? iconPlugin.icons.get(e.element) : null;
                    // Hide the icon
                    iconElement && (iconElement.style.display = 'none');
                }
            }).on('core.validator.validated', function (e) {
                if (!e.result.valid) {
                    // Query all messages
                    const messages = [].slice.call(form.querySelectorAll('[data-field="' + e.field + '"][data-validator]'));
                    messages.forEach((messageEle) => {
                        const validator = messageEle.getAttribute('data-validator');
                        messageEle.style.display = validator === e.validator ? 'block' : 'none';
                    });
                }
            }).on('core.form.validating', function(event) {
                new DismissModal('edit_team_member_modal').disable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
                if(deleteButton){
                    deleteButton.disabled = true;
                }
            }).on('core.form.valid', function(e) {
                // Submit form
                form.submit();
            }).on('core.form.invalid', function(event) {
                new DismissModal('edit_team_member_modal').enable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
                if(deleteButton){
                    deleteButton.disabled = false;
                }
            });
        }
    }
    /** Side actions like Download Setup Files etc. */
    editTeamMemberSideBarActions(vpnUserID, hideConfigFiles){
        const organizationID = this.organizationID;
        $('#frm-generalForms-editTeamMemberForm-editTeamMemberForm .download-ca-certificate').on('click', function() {
            window.location.href = '/certificate/ca/?organizationID='+organizationID;
        });
        if(!hideConfigFiles){
            $('#frm-generalForms-editTeamMemberForm-editTeamMemberForm .download-setup-files').on('click', function() {
                window.location.href = '/team-members/download-setup-files?vpnUserID='+vpnUserID+'&organizationID='+organizationID;
            });

            $('#frm-generalForms-editTeamMemberForm-editTeamMemberForm .reset-mfa-settings').on('click', function() {
                Swal.fire({
                    html: `<span class="text-center text-primary">The user will receive a link via email, which will allow them to set up new MFA.</span>`,
                    icon: "warning",
                    iconColor: "#FF5206",
                    buttonsStyling: false,
                    reverseButtons: true,
                    showCancelButton: true,
                    confirmButtonText: "Send link",
                    customClass: {
                        confirmButton: "btn btn-danger mt-0",
                        cancelButton: 'btn btn-light-primary mt-0',
                    },
                    showLoaderOnConfirm: true,
                    returnFocus: false,
                    preConfirm: () => {
                        return fetch('/team-members/?do=sendLinkToResetMfa&organizationID='+organizationID+'&vpnUserID='+vpnUserID)
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error(response.statusText)
                                }
                                return response.json();
                            }).catch(error => {
                                Swal.showValidationMessage(`Request failed: ${error}`)
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                    allowEscapeKey: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.isConfirmed) {
                        toastr.success('The link to reset MFA settings has been successfully sent!');
                    }
                });
            });

            $('#frm-generalForms-editTeamMemberForm-editTeamMemberForm .open-vpn-config-and-credentials').on('click', function() {
                $.ajax({
                    url: '/team-members/?do=getVpnCredentials',
                    type: 'POST',
                    dataType: '',
                    data: {organizationID: organizationID, vpnUserID: vpnUserID}
                }).done(function(data) {
                    $('#download_openvpn_config_modal #team_member_name').text(data.username);
                    $('#download_openvpn_config_modal #team_member_vpn_password').text(data.vpn_password);
                    $('#download_openvpn_config_modal #team_member_vpn_username').text(data.vpn_username);

                    bootstrap.Modal.getInstance(document.getElementById('edit_team_member_modal')).hide();
                    new bootstrap.Modal(document.getElementById('download_openvpn_config_modal'), {}).show();

                    let gaClipboard = new GaClipboard();
                    gaClipboard.initByID('team_member_vpn_username', 'download_openvpn_config_modal');
                    gaClipboard.initByID('team_member_vpn_password', 'download_openvpn_config_modal');
                })
            });
            $('#download_openvpn_config_modal .download-open-vpn-config-button').on('click', function() {
                window.location.href = '/team-members/download-open-vpn-config?vpnUserID='+vpnUserID+'&organizationID='+organizationID;
            });
            $('#frm-generalForms-editTeamMemberForm-editTeamMemberForm .send-openvpn-config-email').on('click', function() {
                Swal.fire({
                    html: `<span class="text-center text-primary">Send link for Configuration file and Credentials for this member via email ? (Configuration file will be available for next 48 hours)</span>`,
                    icon: "question",
                    iconColor: "#FF5206",
                    buttonsStyling: false,
                    reverseButtons: true,
                    showCancelButton: true,
                    confirmButtonText: "Yes, send it!",
                    customClass: {
                        confirmButton: "btn btn-danger mt-0",
                        cancelButton: 'btn btn-light-primary mt-0',
                    },
                    showLoaderOnConfirm: true,
                    returnFocus: false,
                    preConfirm: () => {
                        return fetch('/team-members/?do=sendSetupFilesByEmail&organizationID='+organizationID+'&vpnUserID='+vpnUserID)
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error(response.statusText)
                                }
                                return response.json();
                            }).catch(error => {
                                Swal.showValidationMessage(`Request failed: ${error}`)
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                    allowEscapeKey: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.isConfirmed) {
                        if(result.value.error === false) {
                            toastr.success('Email with link has been successfully sent!');
                        } else {
                            toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
                        }
                    }
                });
            });
        }

        $('#frm-generalForms-editTeamMemberForm-editTeamMemberForm .resend-invitation-side').on('click', function() {
            Swal.fire({
                html: `<span class="text-center text-primary">Team Member is going to receive another email to join the Organization</span>`,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, Send!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0",
                    cancelButton: 'btn btn-light-primary mt-0',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    return fetch('/team-members/?do=resendInvitation&organizationID='+organizationID+'&vpnUserID='+vpnUserID)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value === 'done') {
                        toastr.success('Email has been sent!');
                    }
                }
            });
        });

        $('#frm-generalForms-editTeamMemberForm-editTeamMemberForm .reset-2fa').on('click', function() {
            Swal.fire({
                html: `<span class="text-center text-primary">Team Member MFA is going to reset!</span>`,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, reset!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0",
                    cancelButton: 'btn btn-light-primary mt-0',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    return fetch('/team-members/?do=resetTwoFaToTeamMember&organizationID='+organizationID+'&vpnUserID='+vpnUserID)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value === 'done') {
                        toastr.success('Member\'s MFA has been reset!');
                    }
                }
            });
        });
        $('#frm-generalForms-editTeamMemberForm-editTeamMemberForm .show-private-ips').on('click', function() {
            $.ajax({
                url: '/team-members/?do=getPrivateIps',
                type: 'POST',
                dataType: '',
                data: {organizationID: organizationID, vpnUserID: vpnUserID}
            }).done(function(data) {
                let html = '';
                if(data.length > 0){
                    html += '<div class="table-responsive">' +
                        '        <table class="table align-middle border ga-border-primary-100 table-rounded table-striped gy-7 px-0 mt-2">' +
                        '            <tbody>';
                    for(let i = 0; i < data.length; i++) {
                        html += '<tr>' +
                            '    <th class="card-rounded-start">' +
                            '       <div class="ps-9 d-flex align-items-center">' +
                            '           <div class="symbol symbol-40px me-3">' +
                            '               <img src="/media/goodaccess/country-flags/png100px/' + data[i].iso2 + '.png" class="w-auto" alt="flag">' +
                            '           </div>' +
                            '           <div class="d-flex justify-content-start flex-column">' +
                            '               <div ' + (data[i].edit ? 'id="'+data[i].uuid+'"' : '') + '><div class="text-nowrap fw-bold text-decoration-underline-ga primary text-primary mb-1 fs-6' + (data[i].edit ? ' edit-gateway' : '') + '">' + data[i].gatewayName + '</div></div>' +
                            '               <span class="fw-semibold d-block fs-7 ga-text-primary-800">' + data[i].iso2.toUpperCase() + ' - ' + data[i].city + '</span>' +
                            '           </div>' +
                            '       </div>'+
                            '    </th>' +
                            '    <td class="card-rounded-end">' +
                            '        <div class="flex-root d-flex align-items-center justify-content-end text-primary pe-9">' +
                            '           <div id="team_member_private_ip_'+i+'" class="text-primary fw-bold text-center fs-4 me-5">'+data[i].privateIp+'/'+data[i].port+'</div>' +
                            '           <button class="btn btn-icon btn-sm btn-light" data-clipboard-target="#team_member_private_ip_'+i+'">' +
                            '               <span class="svg-icon svg-icon-2">' +
                            '                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                            '                        <path opacity="0.5" d="M18 2H9C7.34315 2 6 3.34315 6 5H8C8 4.44772 8.44772 4 9 4H18C18.5523 4 19 4.44772 19 5V16C19 16.5523 18.5523 17 18 17V19C19.6569 19 21 17.6569 21 16V5C21 3.34315 19.6569 2 18 2Z" fill="currentColor"></path>' +
                            '                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7857 7.125H6.21429C5.62255 7.125 5.14286 7.6007 5.14286 8.1875V18.8125C5.14286 19.3993 5.62255 19.875 6.21429 19.875H14.7857C15.3774 19.875 15.8571 19.3993 15.8571 18.8125V8.1875C15.8571 7.6007 15.3774 7.125 14.7857 7.125ZM6.21429 5C4.43908 5 3 6.42709 3 8.1875V18.8125C3 20.5729 4.43909 22 6.21429 22H14.7857C16.5609 22 18 20.5729 18 18.8125V8.1875C18 6.42709 16.5609 5 14.7857 5H6.21429Z" fill="currentColor"></path>' +
                            '                    </svg>' +
                            '               </span>' +
                            '           </button>'+
                            '        </div>' +
                            '    </td>' +
                            '</tr>';
                    }
                    html += '   </tbody>' +
                        '   </table>' +
                        '</div>'
                } else {
                    html += '<span class="text-center">Member private IPs will be available once you have set up the Gateway.</span>';
                }

                $("#team_member_private_ips_modal .modal-body .content").html(html);
                for(let i = 0; i < data.length; i++) {
                    new GaClipboard().initByID('team_member_private_ip_'+i, 'team_member_private_ips_modal');
                }

                bootstrap.Modal.getInstance(document.getElementById('edit_team_member_modal')).hide();
                new bootstrap.Modal(document.getElementById('team_member_private_ips_modal'), {}).show();
            });
        });
    }
}
window.EditMembers = EditMembers;